import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, Loader } from '@marvelapp/ui';
import Page from '../Page';
export default function CenteredLoader() {
    return (_jsx(Page, { title: "Loading", children: _jsx(Flex, { alignItems: "center", justifyContent: "center", minHeight: "100vh", children: _jsx(Loader, { size: 24 }) }) }));
}
